import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $AB from 'jquery';
declare const land_scroll: any;


@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css','../../../assets/css/landing.css']
})
export class LandingComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    land_scroll();
       }

       purchasehovercard($event){
        $(".card-img-top").css('transition','0.35s all'); 
        $(".card-category").css('transition', '0.35s all');
       }
         purchasehovercard2($event){
         $(".card-img-top").css('transition','0.35s all');
         $(".card-category").css('transition', '0.35s all');
         }
      }

